import type { AuthStatus, User } from '@types'
import axios from 'axios'

import env from '../environments'

export async function login(email: string, password: string, captchaToken: string) {
	const response = await axios.post(`${env.apiUrl}/auth/login`, {
		email,
		password,
		captchaToken
	})

	return response.data as User
}

export async function signup(name: string, email: string, password: string) {
	const response = await axios.post(`${env.apiUrl}/auth/signup`, {
		name,
		email,
		password
	})

	return response.data as User
}

export async function getUserStatus() {
	axios.defaults.withCredentials = true
	const response = await axios.get(`${env.apiUrl}/auth/status`)

	return response.data as AuthStatus
}

export async function logout() {
	await axios.post(`${env.apiUrl}/auth/logout`)
}

export async function resetPasswordEmail(email: string) {
	await axios.post(`${env.apiUrl}/auth/reset-password`, { email })
}

export async function resetPassword(token: string, password: string) {
	await axios.post(`${env.apiUrl}/auth/reset-password/${token}`, { password })
}
